module.exports = __webpack_public_path__ + "static/media/Employee.5341f3e9.svg";